let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("60S8F")).then(() => parcelRequire('8JC1j'));